import {
  getSocialEnabled
} from "./chunk-BPQFN7XB.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/auth/socialEnabled.ts
import { useQuery } from "@tanstack/react-query";
var useSocialEnabled = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["social-enabled", { country: props.country, platform: props.platform }],
    queryFn: () => getSocialEnabled(props)
  }, options));
};

export {
  useSocialEnabled
};
//# sourceMappingURL=chunk-NYDH6MLS.mjs.map